<div class="signature-margin">
	<div>{{label}}<span *ngIf="required">*</span></div>
	<signature-pad #signature [options]="signaturePadOptions" (drawStart)="drawStart($event)"
		(drawEnd)="drawComplete($event)" *ngIf="signatureString.length === 0"></signature-pad>
	<div class="signature-margin" class="row margin-top-sm" *ngIf="signatureString.length === 0">
		<div class="col text-center">
			<button class="margin-right-xs" mat-button mat-raised-button (click)="clear()"
				*ngIf="signatureString.length === 0">Clear</button>
			<button mat-button mat-raised-button [color]="'primary'" (click)="sign()"
				*ngIf="signatureString.length === 0">Sign</button>
		</div>
	</div>

	<img alt="Your Signature" *ngIf="signatureString.length > 22"
		[src]="signatureString" aria-label="Signature image, click to resign" />
	<div *ngIf="!hideSignatureClearButton">
		<confirm-popover *ngIf="signatureString.length > 22" [buttonType]="'string'" [icon]="'cancel'" [color]="'warn'"
			[popoverMsg]="'Please Confirm'" [popoverConfirmText]="'Clear'" [popoverConfirmColor]="'Warn'"
			[tooltip]="'Clear Signature'" [buttonTxt]="'Clear'" (onConfirm)="(!disabled) && resign()">
		</confirm-popover>
	</div>
</div>